import React, { useEffect, useState } from 'react';

import './KpiPanel.scss';

export const kpiPanelStorageKey = () => 'cg_kpi_panel';
const PREFERENCE_EVENT = 'cg-kpi-panel-change';

// Machine-local display preference, deliberately outside sign-out filter cleanup.
const KpiPanel = ({ children }) => {
	const storageKey = kpiPanelStorageKey();
	const [isOpen, setIsOpen] = useState(() => {
		try {
			return window.localStorage.getItem(storageKey) === 'true';
		} catch {
			console.warn('KPI panel preference could not be read from local storage.');
			return false;
		}
	});

	useEffect(() => {
		const onPreferenceChange = event => {
			const change = event.type === 'storage' ? event : event.detail;
			if (change.key === storageKey || change.key === null) {
				setIsOpen(change.newValue === 'true');
			}
		};
		window.addEventListener('storage', onPreferenceChange);
		window.addEventListener(PREFERENCE_EVENT, onPreferenceChange);
		return () => {
			window.removeEventListener('storage', onPreferenceChange);
			window.removeEventListener(PREFERENCE_EVENT, onPreferenceChange);
		};
	}, [storageKey]);

	const toggle = () => {
		const nextOpen = !isOpen;
		setIsOpen(nextOpen);
		try {
			window.localStorage.setItem(storageKey, String(nextOpen));
		} catch {
			console.warn('KPI panel preference could not be saved to local storage.');
		}
		// All cached KPI pages share the preference without a reload.
		window.dispatchEvent(new CustomEvent(PREFERENCE_EVENT, {
			detail: { key: storageKey, newValue: String(nextOpen) }
		}));
	};

	const control = (
		<button
			type="button"
			className={`cg-kpi-panel__toggle${isOpen ? '' : ' cg-kpi-panel__toggle--collapsed'}`}
			aria-expanded={isOpen}
			aria-label={isOpen ? 'Collapse KPI' : 'Expand KPI'}
			onClick={toggle}
		>
			{!isOpen && 'KPI '}
			<span aria-hidden="true">{isOpen ? '▾' : '▴'}</span>
		</button>
	);

	// Return only the positioned button when collapsed: no flex item or row gap.
	return isOpen ? (
		<div className="cg-kpi-panel">
			<div className="cg-kpi-panel__cards">{children}</div>
			{control}
		</div>
	) : control;
};

export default KpiPanel;
